import { Box, Stack, Typography, theme } from '@dtx-company/design-system/src'
import { FC, useRef } from 'react'
import { WaysToUseCarouselData } from '../types'

//sectionId is used for navigation
const WaysToUseCarouselSection: FC<{ data?: WaysToUseCarouselData; sectionId?: string }> = ({
  data,
  sectionId
}) => {
  const waysToUseSectionRef = useRef<HTMLDivElement | null>(null)

  if (!data) return null

  return (
    <Stack
      direction="column"
      alignItems="center"
      spacing={theme.spacing(2)}
      ref={waysToUseSectionRef}
      id={sectionId}
      sx={{
        marginTop: theme.spacing(8),
        scrollMarginTop: theme.spacing(25)
      }}
    >
      <Box
        sx={{
          px: { xl: 36 }
        }}
      >
        <Typography variant="headlineMedium" textAlign="center">
          {data.primary?.header}
        </Typography>
      </Box>
      <Box sx={theme => ({ maxWidth: theme.spacing(216.5), textAlign: 'center' })}>
        <Typography variant="bodyMedium">{data.primary?.subheader}</Typography>
      </Box>
    </Stack>
  )
}

export default WaysToUseCarouselSection
